import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from 'mui-rff';

import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';

const SeoBlockHeading = ({ blockName, onBlur, label = 'Heading type' }) => {
	return (
		<>
			<Grid item xs={12} md={4}>
				<TextField
					select
					name={`${blockName}.level`}
					label={label}
					variant="outlined"
					size="small"
					onBlur={onBlur}
				>
					<MenuItem value="h2">H2</MenuItem>
					<MenuItem value="h3">H3</MenuItem>
					<MenuItem value="h4">H4</MenuItem>
					<MenuItem value="h5">H5</MenuItem>
					<MenuItem value="h6">H6</MenuItem>
				</TextField>
			</Grid>
			<Grid item xs={12} md={8}>
				<TextField
					name={`${blockName}.text`}
					label="Heading text"
					variant="outlined"
					size="small"
					onBlur={onBlur}
					fullWidth
				/>
			</Grid>
		</>
	);
};

SeoBlockHeading.propTypes = {
	blockName: PropTypes.string.isRequired,
	onBlur: PropTypes.func.isRequired,
	label: PropTypes.string
};

export default SeoBlockHeading;
